module.exports = __webpack_public_path__ + "d8851ed3d3bff419ad64bc248beab119.png";